import script from "./CustomSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomSelect.vue?vue&type=script&setup=true&lang=js"

import "./CustomSelect.vue?vue&type=style&index=0&id=fe495d4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe495d4e"]])

export default __exports__